import { AnyAction } from 'redux';
import { Type as ControlType } from '../Controls';

export type CommentToSnippet = { [key: string]: string | null };

export interface State {
  commentToSnippet: CommentToSnippet;
}

export const initialState: State = {
  commentToSnippet: {},
};

export enum Type {
  INSERT_COMMENT_SNIPPET = 'COMMENTS/SNIPPETS/INSERT_COMMENT_SNIPPET',
}

interface Action<T> {
  type: T;
}

export interface InsertCommentSnippet
  extends Action<Type.INSERT_COMMENT_SNIPPET> {
  commentUUID: string;
  snippet: string | null;
}

export default (state = initialState, action: AnyAction): State => {
  switch (action.type) {
    case ControlType.SET_ORGANIZATION_UUID:
      return {
        commentToSnippet: {},
      };
    case Type.INSERT_COMMENT_SNIPPET:
      const newCommentToSnippet = {
        ...state.commentToSnippet,
      };

      newCommentToSnippet[action.commentUUID] = action.snippet;

      return {
        ...state,
        commentToSnippet: newCommentToSnippet,
      };
    default:
      return state;
  }
};

interface InsertCommentSnippetInput {
  commentUUID: string;
  snippet: string | null;
}

export const actions = {
  insertCommentSnippet: ({
    commentUUID,
    snippet,
  }: InsertCommentSnippetInput): InsertCommentSnippet => ({
    type: Type.INSERT_COMMENT_SNIPPET,
    commentUUID,
    snippet,
  }),
};
